import { useMemo } from 'react';
import usePath from '../../../../../components/Hooks/usePath';
import LangEnum from '../../../../../lang/LangEnum';
import PATHS from '../../../../../routes/routes.const';
import { useFindClassificationTypes } from '../../../../../services/modules/classificationTypes/classificationTypes.queries';
import { ClassificationTypeEntityEnum } from '../../../../classifications/classification.types';
import { OrderHeadersGroupByEnum } from '../../../products/orderProducts.types';
import { OptionType, getDefaultOptions } from '../../../products/review/orderProductsReview.types';
import { GroupByOptions } from '../ExportOrderModal.types';
import { makeGroupByEnumPrefix } from '../utils/exportOrder.utils';

export const usePdfBaseOptions = () => {
  const { isPath } = usePath();
  const isOrderEditPage = isPath(PATHS.main.orders.editForm.path);
  const defaults = getDefaultOptions({ isOrderEditPage, withImageOptions: true });
  const orderByOptions: OptionType[] = defaults.sortBy;
  const baseGroupBy: OptionType[] = defaults.groupBy;

  const { data, isLoading, isFetching, error } = useFindClassificationTypes({
    useAsFilter: true,
    limit: 100,
    skip: 0,
    entity: ClassificationTypeEntityEnum.PRODUCT_COLOR,
  });

  const colorGroupByOptions: GroupByOptions[] = useMemo(() => {
    const list = data?.data ?? [];
    return list.map((ct) => ({
      value: makeGroupByEnumPrefix(OrderHeadersGroupByEnum.COLOR_CLASSIFICATION_TYPE, ct.id),
      label: ct.name as LangEnum,
    }));
  }, [data]);

  const groupByOptions = useMemo(
    () => [...baseGroupBy, ...colorGroupByOptions],
    [baseGroupBy, colorGroupByOptions],
  );

  return {
    groupByOptions,
    orderByOptions,
    loading: Boolean(isLoading || isFetching),
    error,
  };
};
